
import Vue from 'vue'
import { mapState } from 'vuex';
import Catalog from "@/views/StorePages/Catalog.vue"
import _requestHelper from '@/apiManager/_requestHelper';
export default Vue.extend({
    components: {
        catalog: Catalog
    },

    props: {
        // items to be displayed
        items: {
            required: true
        },
    },

    data: () => ({
        catalogDialog: false as boolean,
        catalogImages: [] as string[]
    }),

    computed: {
        ...mapState("store", ["selectedStoreDetails"]),
        ...mapState("ui", ["isMobileViewDisplayed"])
    },

    methods: {
        getBannerSheetStyle(bannerInfo: any) : string {
            return `background-color: #${bannerInfo.bannerMainColor.replace('0xFF', '')} !important;
                    border-radius: 18px !important;
                    width: 100% !important

            `
        },

        getImageStyle(bannerInfo: any) : string {
            return `cursor: ${bannerInfo.bannerActionType == 1 || bannerInfo.bannerActionType == 4 ? 'pointer' : 'default' } !important; object-fit:contain`
        },

        async onBannerClick(banner: any) {
            if(banner.bannerInfo.bannerActionType == 1) {
                this.$router.push({
                    name: "productsPageByCampaign",
                    params: {
                        campaignId: banner.id,
                        campaignName: banner.campaignInfo.name,
                        campaignCollectionType: banner.itemsCollectionType,
                        title: banner.campaignInfo.name,
                    },
                    
                    query: {
                        type: banner.itemsCollectionType,
                        typeId: banner.itemsCollectionId,
                    }

                });
            }

            else if(banner.bannerInfo.bannerActionType == 3){
                var anchor = document.createElement('a');
                anchor.href = banner.bannerInfo.onClickGoToURL;
                anchor.target="_blank"
                anchor.click();
                anchor.remove();
            }

            else if(banner.bannerInfo.bannerActionType == 4){
                await this.getCatalogImages(banner.id)

                if(this.catalogImages.length > 0) {
                    this.catalogDialog = true
                }
            }

        },

        
        async getCatalogImages(id: number) {
            await _requestHelper({
                method: "post",
                url: "items/catalog",
                data: {
                    campaignId: id
                },
                successCallback: (data: any) => {
                    this.catalogImages = data.images;
                }
            })
        }
    },

})
